<div>
    <app-employee-form></app-employee-form>
</div>
<div>
    <app-employee-list></app-employee-list>
</div>